import React from "react";
import { Link } from "react-router-dom";
import "./PurpleCTAButton.css";
import arrowIcon from "../../assets/rightarrow.svg";

const PurpleCTAButton = ({
  to = "/",
  text = "Read Full Blog",
  className = "",
  variant = "pill",
  onClick,
  'data-track-cta': dataTrackCta,
  trackingName,
  ...rest
}) => {
  const ctaAttr = trackingName || dataTrackCta;
  const inner = (
    <>
      <span className="purpleBtn__text">{text}</span>
      <span className="purpleBtn__icon">
        <img src={arrowIcon} alt="Arrow" />
      </span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={`purpleBtn purpleBtn--${variant} ${className}`}
        onClick={onClick}
        data-track-cta={ctaAttr}
        {...rest}
      >
        {inner}
      </button>
    );
  }

  return (
    <Link
      to={to}
      className={`purpleBtn purpleBtn--${variant} ${className}`}
      data-track-cta={ctaAttr}
      {...rest}
    >
      {inner}
    </Link>
  );
};

export default PurpleCTAButton;
